(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-color-swatches"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__ccsInit) return;
    window.__ccsInit = true;

    function findImg(sw) {
      var card = sw.closest('product-card, .cto__card, .rl__card');
      if (!card) return null;
      var imgs = card.querySelectorAll('img');
      for (var i = 0; i < imgs.length; i++) {
        if (!imgs[i].closest('.ccs')) return imgs[i];
      }
      return null;
    }

    function preview(sw) {
      var img = findImg(sw);
      var url = sw.getAttribute('data-img');
      if (!img || !url) return;
      if (!img.hasAttribute('data-ccs-src')) {
        img.setAttribute('data-ccs-src', img.getAttribute('src') || '');
        img.setAttribute('data-ccs-srcset', img.getAttribute('srcset') || '');
      }
      img.removeAttribute('srcset');
      img.src = url;
      sw.__ccsImg = img;
    }

    function reset(sw) {
      var img = sw.__ccsImg;
      if (!img || !img.hasAttribute('data-ccs-src')) return;
      img.src = img.getAttribute('data-ccs-src');
      var ss = img.getAttribute('data-ccs-srcset');
      if (ss) img.setAttribute('srcset', ss);
      img.removeAttribute('data-ccs-src');
      img.removeAttribute('data-ccs-srcset');
    }

    document.addEventListener('pointerover', function (e) {
      if (e.pointerType === 'touch' || !e.target.closest) return;
      var sw = e.target.closest('.ccs__sw');
      if (sw && !(e.relatedTarget && sw.contains(e.relatedTarget))) preview(sw);
    });

    document.addEventListener('pointerout', function (e) {
      if (!e.target.closest) return;
      var sw = e.target.closest('.ccs__sw');
      if (sw && !(e.relatedTarget && sw.contains(e.relatedTarget))) reset(sw);
    });

    function go(e) {
      if (!e.target.closest) return;
      var el = e.target.closest('.ccs__sw, .ccs__more');
      if (!el) return;
      if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault();
      e.stopPropagation();
      var href = el.getAttribute('data-href');
      if (href) window.location.href = href;
    }

    document.addEventListener('click', go, true);
    document.addEventListener('keydown', go, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
